import React, { Dispatch, SetStateAction } from 'react';
import { PUBLIC_SITE_URL } from 'appConstants';

type MONonUKNoVATProps = {
  setCurrentStep: Dispatch<SetStateAction<number | string>>;
  membershipQuestions: any;
  setMembershipQuestions: Dispatch<any>;
};

export const MONonUKNoVAT: React.FC<MONonUKNoVATProps> = ({
  setCurrentStep,
  membershipQuestions,
  setMembershipQuestions,
}) => {
  const continueWithoutVAT = () => {
    setMembershipQuestions({
      ...membershipQuestions,
      noVATNumberApplied: true,
    });
    setCurrentStep(2);
  };

  return (
    <>
      <div className="MOQForm">
        <h3 className="MFBoldNotice">
          If you do not have a VAT number, please <a href={`${PUBLIC_SITE_URL}/contact-us`} target="_blank" rel="noreferrer">contact us</a> before purchasing so we can verify your organisation.
        </h3>
        <div className="Btn BtnWhite BackBtn" onClick={() => setCurrentStep('NonUK')}>
          Back
        </div>
      </div>
    </>
  );
};
